export default __webpack_public_path__ + "static/media/american_express.1da51434.svg";